export default __webpack_public_path__ + "static/media/feb-22.9c11a49b.jpg";